
import SEO from '@/components/SEO';
import { OG_IMAGES } from '@/constants/seoImages';
import HeroSection from '@/components/sponsor/HeroSection';
import WhySeniorThriveSection from '@/components/sponsor/WhySeniorThriveSection';
import TargetProfessionsSection from '@/components/sponsor/TargetProfessionsSection';
import ProcessSection from '@/components/sponsor/ProcessSection';
import PrivacySection from '@/components/sponsor/PrivacySection';
import SponsorshipTiers from '@/components/sponsor/SponsorshipTiers';
import ValueStorySection from '@/components/sponsor/ValueStorySection';
import TestimonialsSection from '@/components/sponsor/TestimonialsSection';
import CTASection from '@/components/sponsor/CTASection';

const Sponsorship = () => {
  return (
    <>
      <SEO
        title="Advisor Platform - Embed Aging-at-Home Strategy Into Your Practice | SeniorThrive"
        description="SeniorThrive helps advisors protect client independence, strengthen multi-generational relationships, and stay indispensable as families navigate aging. Explore advisor platform licensing."
        keywords="advisor platform, aging strategy, client relationships, financial advisor, elder care, senior safety, aging in place, advisor partnership"
        canonical="https://seniorthrive.com/sponsor-older-adults"
        image={OG_IMAGES.sponsorship}
      />

      <HeroSection />
      <WhySeniorThriveSection />
      <TargetProfessionsSection />
      <ProcessSection />
      <PrivacySection />
      <SponsorshipTiers />
      <ValueStorySection />
      <TestimonialsSection />
      <CTASection />
    </>
  );
};

export default Sponsorship;
